export const BRIA_USER_ASSETS = "bria-user-assets";
export const BRIA_QUALCOMM_SERVER_HOST = "http://localhost:8000";
export const MICROSOFT_PROVIDER_ID = "microsoft.com";
export const GOOGLE_PROVIDER_ID = "google.com";
export const GITHUB_PROVIDER_ID = "github.com";
